const init = () => {
  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: '#adbc05',
      },
      button: {
        background: '#000000',
      },
    },
    content: {
      message: 'Na tejto stránke používame súbory cookies. Ukladáme ich výhradne pre potreby Google Analytics, aby sme vedeli vyhodnotiť spôsob, akým našu stránku používate a do budúcna ju vylepšiť. Viac informácií o používaní súborov cookies zo strany Google Analytics sa dozviete <a href="https://policies.google.com/technologies/types?hl=sk" target="_blank" rel="noopener noreferrer">tu</a>. Ukladaniu súborov cookies vo vašom koncovom zariadení môžete zabrániť zmenou nastavenia vášho webového prehliadača.',
      dismiss: 'OK',
      link: 'Viac...',
      href: '/gdpr',
    },
  })
}

export default () => {
  if (window.cookieconsent) {
    init()
  } else {
    window.addEventListener('load', init)
  }
}



// WEBPACK FOOTER //
// ./src/cookiesConsent.js